import { Link } from 'react-router-dom';

const downloadPlatforms = [
  {
    name: 'Android',
    icon: 'ri-android-line',
    version: 'V8.0.1',
    size: '2.5GB',
    description: '适用于安卓8.0及以上系统',
    color: 'bg-accent-500',
  },
  {
    name: 'iOS',
    icon: 'ri-apple-line',
    version: 'V8.0.1',
    size: '2.6GB',
    description: '适用于iOS 13及以上系统',
    color: 'bg-primary-500',
  },
  {
    name: 'PC',
    icon: 'ri-computer-line',
    version: 'V8.0.1',
    size: '4.8GB',
    description: '适用于Windows 10/11系统',
    color: 'bg-secondary-500',
  },
];

const features = [
  {
    icon: 'ri-sword-line',
    title: '热血国战',
    description: '万人同屏国战，十大国家势力争霸，体验最热血刺激的大型PVP战斗。每周国战、王城争夺战、边境战等多种玩法等你来战。',
  },
  {
    icon: 'ri-group-line',
    title: '帮派社交',
    description: '加入帮派，与兄弟并肩作战。帮派副本、帮派战、帮派任务，丰富的帮派玩法让你不再孤单。结识志同道合的战友，共创辉煌。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '五大职业',
    description: '战士、法师、弓手、仙术、召唤，五大经典职业任你选择。每个职业拥有独特的技能体系和成长路线，找到最适合你的战斗风格。',
  },
  {
    icon: 'ri-image-line',
    title: '精美画面',
    description: '采用最新游戏引擎打造，精美的中国风场景和角色设计。从繁华王城到苍茫边塞，从幽深古墓到仙山琼阁，每一帧都是壁纸级画面。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '装备养成',
    description: '丰富的装备养成系统：强化、附魔、觉醒、套装，打造你的专属神器。数百种装备外观，展现你的独特个性和强大实力。',
  },
  {
    icon: 'ri-global-line',
    title: '跨服竞技',
    description: 'V8.0全新跨服战场系统，打破服务器壁垒。龙城争霸、跨服排位赛，与全服高手一决高下，争夺至尊荣耀。',
  },
];

export default function HomePage() {
  const scrollToDownload = () => {
    const el = document.getElementById('download-section');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <main>
      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20MMORPG%20battlefield%20scene%2C%20thousands%20of%20ancient%20Chinese%20warriors%20in%20golden%20and%20red%20armor%20marching%20across%20vast%20battlefield%20at%20sunset%2C%20dramatic%20clouds%2C%20floating%20banners%2C%20ancient%20Chinese%20architecture%20in%20distance%2C%20cinematic%20game%20art%2C%20warm%20golden%20and%20crimson%20tones%2C%20epic%20scale%2C%20atmospheric&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="征途国际热血国战MMORPG"
            title="征途国际官方正版游戏"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 text-center">
          <div className="w-full max-w-3xl">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-4 leading-tight">
              征途国际
              <span className="block text-2xl md:text-3xl lg:text-4xl font-bold mt-2 text-accent-300">
                官方正版 · 热血国战
              </span>
            </h1>
            <p className="text-base md:text-lg text-background-200 mb-8 max-w-xl mx-auto leading-relaxed">
              经典热血国战MMORPG手游，全球5000万玩家的共同选择。
              支持Android、iOS及PC端，安全无毒，一键下载安装。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={scrollToDownload}
                className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-download-line text-lg"></i>
                立即下载
              </button>
              <Link
                to="/categories"
                className="px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg text-base font-medium hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap"
              >
                查看攻略
              </Link>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
      </section>

      {/* Stats Bar */}
      <section className="bg-background-50 -mt-1 relative z-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-8">
            {[
              { value: '5000万+', label: '全球注册用户' },
              { value: '150+', label: '覆盖国家和地区' },
              { value: '4.8', label: 'App Store评分' },
              { value: '7×24', label: '客服在线支持' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section id="download-section" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              选择你的平台，开始征战
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
              征途国际全面支持三大平台，选择适合你的设备下载安装
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {downloadPlatforms.map((platform) => (
              <div
                key={platform.name}
                className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 ${platform.color} rounded-xl flex items-center justify-center mb-5 group-hover:scale-105 transition-transform`}>
                  <i className={`${platform.icon} text-background-50 text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2">
                  {platform.name} 端下载
                </h3>
                <div className="flex items-center gap-4 text-sm text-foreground-500 mb-2">
                  <span>版本 {platform.version}</span>
                  <span>{platform.size}</span>
                </div>
                <p className="text-sm text-foreground-600 mb-5">{platform.description}</p>
                <button className="w-full px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer">
                  <i className="ri-download-line"></i>
                  一键下载
                </button>
              </div>
            ))}
          </div>
          <p className="text-center text-xs text-foreground-400 mt-6">
            温馨提示：请从官方渠道下载，确保游戏安全无毒。安装前请确认设备满足最低配置要求。
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              为什么选择征途国际？
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
              六大核心特色，打造极致的国战游戏体验
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group"
              >
                <div className="w-11 h-11 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${feature.icon} text-primary-600 text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Game Screenshot Gallery */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              游戏实景截图
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
              精美中国风画面，身临其境的国战体验
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <div className="rounded-xl overflow-hidden bg-background-200">
              <div className="aspect-video">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20fantasy%20MMORPG%20game%20screenshot%2C%20ancient%20Chinese%20city%20with%20crowded%20marketplace%2C%20colorful%20NPCs%20and%20players%2C%20traditional%20Chinese%20architecture%2C%20warm%20golden%20lighting%2C%20game%20UI%20interface%2C%20high%20quality%20game%20graphics&width=800&height=450&seq=screenshot-01&orientation=landscape"
                  alt="征途国际王城场景截图"
                  title="征途国际王城-国战中心"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="rounded-xl overflow-hidden bg-background-200">
              <div className="aspect-video">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20fantasy%20MMORPG%20battle%20gameplay%20screenshot%2C%20epic%20large%20scale%20PvP%20combat%20with%20special%20effects%2C%20warriors%20fighting%20on%20ancient%20battlefield%2C%20dramatic%20skill%20effects%2C%20golden%20and%20red%20color%20scheme%2C%20game%20screenshot&width=800&height=450&seq=screenshot-02&orientation=landscape"
                  alt="征途国际国战战斗截图"
                  title="征途国际万人国战实景"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="rounded-xl overflow-hidden bg-background-200">
              <div className="aspect-video">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20fantasy%20MMORPG%20character%20customization%20screen%2C%20beautiful%20armored%20characters%20with%20elaborate%20costumes%20and%20weapons%2C%20ancient%20Chinese%20palace%20background%2C%20rich%20golden%20and%20red%20decorations%2C%20game%20screenshot%20style&width=800&height=450&seq=screenshot-03&orientation=landscape"
                  alt="征途国际角色装备展示"
                  title="征途国际精美装备外观展示"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Latest News */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
                最新资讯
              </h2>
              <p className="text-sm text-foreground-600">掌握征途国际最新动态与攻略</p>
            </div>
            <Link
              to="/articles"
              className="px-5 py-2.5 bg-secondary-100 text-secondary-700 rounded-lg text-sm font-medium hover:bg-secondary-200 transition-all duration-200 whitespace-nowrap flex items-center gap-2"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              {
                slug: 'xinshou-ru-men-gonglue-2026',
                title: '征途国际2026新手入门全攻略：从零开始征战天下',
                category: '游戏攻略',
                date: '2026-08-10',
                image: 'https://readdy.ai/api/search-image?query=Chinese%20MMORPG%20new%20player%20guide%20illustration%2C%20young%20warrior%20starting%20journey%20in%20ancient%20Chinese%20fantasy%20world%2C%20warm%20encouraging%20atmosphere%2C%20game%20tutorial%20art%20style%2C%20golden%20lighting&width=800&height=450&seq=news-home-01&orientation=landscape',
              },
              {
                slug: 'zhiye-pk-2026-paiming',
                title: '征途国际2026职业强度排名：五大职业PVP实力解析',
                category: '游戏攻略',
                date: '2026-08-08',
                image: 'https://readdy.ai/api/search-image?query=Chinese%20MMORPG%20character%20class%20comparison%20showcase%2C%20five%20different%20classes%20standing%20in%20heroic%20poses%2C%20ancient%20Chinese%20temple%20background%2C%20dramatic%20composition%2C%20game%20art%20style&width=800&height=450&seq=news-home-02&orientation=landscape',
              },
              {
                slug: 'v8-banben-gengxin-gonggao',
                title: '征途国际V8.0版本更新公告：全新跨服战场即将开启',
                category: '官方公告',
                date: '2026-08-10',
                image: 'https://readdy.ai/api/search-image?query=Grand%20game%20version%20update%20announcement%20visual%2C%20dragon%20rising%20from%20ancient%20Chinese%20city%2C%20epic%20cinematic%20composition%2C%20warm%20golden%20radiance%2C%20celebratory%20atmosphere%2C%20game%20promotional%20art&width=800&height=450&seq=news-home-03&orientation=landscape',
              },
            ].map((item) => (
              <Link
                key={item.slug}
                to={`/articles/${item.slug}`}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs bg-accent-100 text-accent-700 px-2.5 py-1 rounded-full font-medium">
                      {item.category}
                    </span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              关于征途国际，你想知道的都在这里
            </p>
          </div>
          <div className="space-y-3">
            {[
              { q: '征途国际是什么类型的游戏？', a: '征途国际是一款经典热血国战MMORPG手游，以中国古代战国时期为背景，玩家可以选择不同职业，参与万人国战、帮派争霸、跨服战场等多种PVP玩法。' },
              { q: '征途国际支持哪些平台？', a: '征途国际全面支持Android安卓、iOS苹果以及PC电脑端三平台。您可以在本页面根据您的设备选择对应的下载入口，一键下载安装。' },
              { q: '游戏安装包有多大？对手机配置有什么要求？', a: '征途国际安装包约2.5GB，建议预留5GB以上存储空间。推荐配置：Android 8.0以上、iOS 13以上、运行内存4GB以上。' },
              { q: '下载安装后无法启动怎么办？', a: '请尝试：1.确认设备系统版本满足最低要求；2.清理手机缓存并重启设备；3.卸载后重新从官方渠道下载安装；4.如仍无法解决，请联系官方客服。' },
            ].map((faq, i) => (
              <details
                key={i}
                className="group bg-background-50 rounded-xl border border-background-200/70"
              >
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer font-medium text-foreground-900 text-sm list-none">
                  {faq.q}
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg"></i>
                </summary>
                <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20sunset%20battlefield%20with%20silhouettes%20of%20warriors%20raising%20swords%2C%20dramatic%20golden%20sky%20with%20crimson%20clouds%2C%20ancient%20Chinese%20banners%20in%20wind%2C%20inspirational%20and%20heroic%20atmosphere%2C%20cinematic%20wide%20composition&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
            alt="征途国际-立即加入"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-3xl mx-auto text-center px-4">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            准备好了吗？加入征途国际
          </h2>
          <p className="text-background-200 text-sm md:text-base mb-8 max-w-lg mx-auto">
            全球5000万玩家的共同选择，热血国战，等你来战！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={scrollToDownload}
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap flex items-center gap-2 cursor-pointer"
            >
              <i className="ri-download-line text-lg"></i>
              免费下载
            </button>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg text-base font-medium hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}